import { configureStore } from "@reduxjs/toolkit"
import product from "./product"
import service from "./service"
import farmer from "./farmer"
import customer from "./customer"
import hauller from "./hauller"
import processingcenter from "./processingcenter"
import warehouse from "./warehouse"
import supplychain from "./supplychain"
import sales from "./sales"
import staff from "./staff"
import commodity from "./commodity"
import contract from "./contract"
import inventory from "./inventory"
import purchase from "./purchase"
import expenses from "./expenses"
import agent from "./agent"
import stock from "./stock"
import cashsales from "./cashsales"
import mechanization from "./mechanization"
import admin from "./admin"
import authSlice from "../features/authSlice"

export default configureStore({
    reducer: {
        auth: authSlice,
        stock: stock,
        cashsales: cashsales,
        mechanization: mechanization,
        product: product,
        agent: agent,
        admin: admin,
        expenses: expenses,
        purchase: purchase,
        service: service,
        farmer: farmer,
        customer: customer,
        hauler: hauller,
        warehouse: warehouse,
        processingcenter: processingcenter,
        supplychain: supplychain,
        sales: sales,
        contract: contract,
        commodity: commodity,
        staff: staff,
        inventory: inventory
    },
})